module.exports = __webpack_public_path__ + "static/media/img-dentist-product-4@3x.7e415a47.png";